import DateInput from "@/components/Common/DateInput/DateInput.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { stateItems } from "@/configuration/formConfigurations";
export default {
  components: { DateInput, InfoDialog },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems
  })
};
